module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe-gcc.com/en_sa/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe-gcc.com/en_sa/company/legal-info.html",
	"footer.copyright": "&copy; 2018 Grome Marketing (Cyprus) Ltd.",
	"homepage.headline": "معدّ GROHE SmartControl",
	"homepage.introtext": "أجب عن بعض الأسئلة أدناه لإعداد نظام دش GROHE SmartControl الذي يلائم إحتياجاتك.",
	"homepage.buttonStart": "إبدأ",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "إطّلع على النتائج",
	"question1.question": "تحتاج إلى إعداد الدش لأي منطقة في حمامك؟",
	"question1.option1.text": "لمنطقة إستحمامي",
	"question1.option2.text": "لحوض الإستحمام بما في ذلك الحنفية",
	"question2.question": "ما هو نوع التركيب الذي تفضّله؟ المكشوف أو المخفي أو مزيج من الإثنين؟",
	"question2.option1.text": "المكشوف: حل سهل وقليل الجهد للتعديل والتحديث أمام الجدار",
	"question2.option2.text": "المزيج: أنابيب مخفية داخل الجدار ومنظم حرارة مع طبق أمام الجدار",
	"question2.option3.text": "المخفي: مظهر أنيق وبسيط مع إخفاء كل التقنيات داخل الجدار",
	"question3.question": "كيف تفضّل تشغيل الدش الخاص بك؟",
	"question3.option1.text": "مع SmartControl ومنظم للحرارة",
	"question3.option2.text": "بتشغيل تقليدي ومنظم للحرارة ",
	"question3.option3.text": "بخلاط بذراع واحدة",
	"question3.option4.text": "عبر نظام تحويل (مع إبقاء الحنفية الموجودة)",
	"question4.question": "ما الذي تريد التحكم به من خلال الدش الخاص بك؟",
	"question4.option1.text": "فقط ذراع الدش",
	"question4.option2.text": "دش رأسي كبير (150 – 250mm) وذراع الدش",
	"question4.option3.text": "دش رأسي كبير جداً  (250-400mm) وذراع الدش",
	"question4.option4.text": "دش رأسي كبير (150 – 250mm)، ذراع الدش، وحنفية حوض الإستحمام",
	"question4.option5.text": "دش رأسي كبير جداً (250-400mm)، ذراع الدش، وحنفية حوض الإستحمام",
	"question5.question": "ما هو الشكل الذي تفضّله؟",
	"question5.option1.text": "مربّع",
	"question5.option2.text": "دائري",
	"question6.question": "ما الذي تريد التحكم به من خلال SmartControl الجديد؟",
	"question6.option1.text": "الدش الرأسي مع رذاذين وذراع الدش",
	"question6.option2.text": "الدش الرأسي مع رذاذين وذراع الدش",
	"question6.option3.text": "الدش الرأسي، ذراع الدش وحنفية حوض الإستحمام",
	"question6.option4.text": "الدش الرأسي، دشين جانبيين وذراع الدش",
	"question6.option5.text": "الدش الرأسي وذراع الدش",
	"question6.option6.text": "ذراع الدش وحنفية حوض الإستحمام",
	"question6.option7.text": "فقط ذراع الدش",
	"question6.option8.text": "فقط حنفية حوض الإستحمام",
	"question7.question": "إختر اللون الخاص بك",
	"question7.option1.text": "كروم",
	"question7.option2.text": "أبيض/كروم",
	"question7.option3.text": "أبيض/كروم",
	"question8.question": "هل تودّ الحصول على منظم حرارة مع حاملة ذراع الدش؟",
	"question8.option1.text": "نعم، أريد الحصول على حاملة ذراع الدش",
	"question8.option2.text": "كلا، سأشتري حاملة ذراع الدش على حدة",
	"question9.question": "كيف تفضّل أن يتم حمل ذراع الدش؟",
	"question9.option1.text": "بواسطة سكة دش مع حاملة دش بإرتفاع قابل للتعديل",
	"question9.option2.text": "بواسطة حاملة دش بسيطة ",
	"question10.question": "هل تودّ تعليق الدش الرأسي على الجدار أو في السقف؟",
	"question10.option1.text": "دش رأسي معلّق على الجدار",
	"question10.option2.text": "دش رأسي معلّق في السقف",
	"results.title": "{productGroupsCount, plural, \none {نتائجكم} \nother {نتائجك}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "للحصول على التركيب الملائم، تحتاج إلى:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "إبدأ إعداد جديد",
	"results.product.number": "رقم المنتج: #{number}",
	"results.product.button.productInformation": "معلومات عن المنتج",
	"results.product.button.dealerLocator": "قم بإيجاد صالة عرض",
	"results.product.button.buyNow": "إشتري عبر الإنترنت",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "معلومات عن المنتج",
	"results.product.dealer": "قم بإيجاد صالة عرض",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.ar_sa.json
// module id = 744
// module chunks = 0